import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content is-small" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Steuerung"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Linksklick + Ziehen: Neues Türchen erstellen"),
    /*#__PURE__*/_createElementVNode("li", null, "Rechtsklick + Ziehen: Türchen verschieben"),
    /*#__PURE__*/_createElementVNode("li", null, "Doppel- oder Mittelklick: Türchen löschen")
  ])
], -1)
const _hoisted_3 = { class: "image is-unselectable" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoorCanvas = _resolveComponent("DoorCanvas")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("figure", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.store.calendar_background_image
      }, null, 8, _hoisted_4),
      _createVNode(_component_DoorCanvas, { doors: _ctx.doors }, null, 8, ["doors"])
    ])
  ]))
}